<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Sorteo Desde"
            label-for="fechaSorteoDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaSorteoDesde" 
              v-model="filtro.fechaSorteoDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Sorteo Hasta"
            label-for="fechaSorteoHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaSorteoHasta" 
              v-model="filtro.fechaSorteoHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="sortByDescending"
                v-model="filtro.sortByDescending"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
                Ordenar sorteos en forma descendente
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <!-- <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
        </div> -->
      </b-collapse>
      <div slot="footer" v-if="showOpcionesFiltro">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    fechaSorteoDesde: {
      type: String,
      default: ''
    },
    fechaSorteoHasta: {
      type: String,
      default: ''
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaSorteoDesde: '',
        fechaSorteoHasta: '',
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2
    }
  },
  created() {
      this.filtro.fechaSorteoDesde = moment.utc(this.fechaSorteoDesde).format('YYYY-MM-DD');
      this.filtro.fechaSorteoHasta = moment.utc(this.fechaSorteoHasta).format('YYYY-MM-DD');
      this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
    },
  },
}
</script>

<style>
</style>
